import { Property } from "./interfaces";

export const vrUnitMedicamento: Property = {
    title: "Valor Unitario del Medicamento",
    type: "integer"
}